const Colors = ['#FF3F8E', '#04C2C9', '#2E55C1'];

export default Colors;
